import { PROYECT, api_delete, api_get, api_post, api_put } from "services/api";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import electronicEquipmentActionTypes, { loadingActions } from "redux/reducers/electronicEquipment/types";

const {
  ADD_ELECTRONIC_EQUIPMENT,
  DELETE_ELECTRONIC_EQUIPMENT,
  EDIT_ELECTRONIC_EQUIPMENT,
  GET_ELECTRONIC_EQUIPMENT_TYPES,
  GET_ELECTRONIC_EQUIPMENT_DATA,
  SET_ELECTRONIC_EQUIPMENT_SEARCH_FILTERS
} = electronicEquipmentActionTypes;

const { ADD, DELETE, EDIT, GET, GET_TYPES, } = loadingActions;

const BASE_URL = `${process.env.REACT_APP_URL}${PROYECT}/equipments`;

export const addElectronicEquipment = (formValues, onSuccess) => async (dispatch) => {
  dispatch(startRequestComp(ADD));

  try {
    const resp = await api_post(BASE_URL, formValues);
    dispatch({
      type: ADD_ELECTRONIC_EQUIPMENT,
      payload: { ...resp, status: formValues.status },
    });
    dispatch(setSnackbar("El equipo electrónico fue creado con éxito", "success"));
    if (onSuccess) onSuccess();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp(ADD));
  }
};

export const deleteElectronicEquipment = (equipmentId, onSuccess) => async (dispatch) => {
  const url = `${BASE_URL}/${equipmentId}`;
  dispatch(startRequestComp(DELETE));

  try {
    await api_delete(url);
    dispatch({ type: DELETE_ELECTRONIC_EQUIPMENT, payload: equipmentId });
    dispatch(setSnackbar("El equipo electrónico fue eliminado con éxito", "success"));
    if (onSuccess) onSuccess();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp(DELETE));
  }
};

export const editElectronicEquipment = (equipmentId, formValues, onSuccess) => async (dispatch) => {
  const url = `${BASE_URL}/${equipmentId}`;
  dispatch(startRequestComp(EDIT));

  try {
    const resp = await api_put(url, formValues);
    dispatch({ type: EDIT_ELECTRONIC_EQUIPMENT, payload: resp });
    dispatch(setSnackbar("El equipo electrónico fue editado con éxito", "success"));
    if (onSuccess) onSuccess();
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp(EDIT));
  }
};

export const getElectronicEquipment = (stationId) => async (dispatch) => {
  const url = `${BASE_URL}?stations=${stationId}`;
  dispatch(startRequestComp(GET));

  try {
    const resp = await api_get(url);
    if (!resp.length) {
      dispatch(setSnackbar("No se encontraron equipos electrónicos para la planta seleccionada.", "warning"));
    }
    dispatch({ type: GET_ELECTRONIC_EQUIPMENT_DATA, payload: resp });
  } catch (error) {
    dispatch(setSnackbar(error));
  } finally {
    dispatch(stopRequestComp(GET));
  }
};

export const getElectronicEquipmentTypes = () => async (dispatch) => {
  const url = `${BASE_URL}/types`;
  dispatch(startRequestComp(GET_TYPES));

  try {
    const resp = await api_get(url);
    dispatch({ type: GET_ELECTRONIC_EQUIPMENT_TYPES, payload: resp });
  } catch (error) {
    dispatch(setSnackbar(error || "Error al cargar los tipos de equipos electrónicos"));
  } finally {
    dispatch(stopRequestComp(GET_TYPES));
  }
};

export const setElectronicEquipmentSearchFilters = (key, value) => ({
  type: SET_ELECTRONIC_EQUIPMENT_SEARCH_FILTERS,
  payload: { key, value },
});
